export const contactInfo = {
  address: '1-9-1120/1, O.U. MAIN ROAD, VIDYANAGAR-500044',
  phone: '+91 81435 85288',
  email: 'happyfaceshyderabad@gmail.com',
  helpline: '+91 81435 85288',
  hours: 'Monday - Saturday: 9:00 AM - 6:00 PM IST',
};

export const officeLocations = [
  {
    city: 'Hyderabad',
    address: '1-9-1120/1, O.U. MAIN ROAD, VIDYANAGAR-500044',
    phone: '+91 81435 85288',
    email: 'happyfaceshyderabad@gmail.com',
    isHeadquarters: true,
  },
];

export const contactFaqs = [
  {
    question: 'How can I donate to Happy Faces Society?',
    answer: 'You can donate online through our secure donation page using UPI, credit/debit cards, net banking, or wallets. For offline donations, you can transfer via NEFT/RTGS to our bank account or send a cheque/demand draft payable to "Happy Faces Society" to our Hyderabad office. All donations are eligible for 80G tax benefits.',
  },
  {
    question: 'Are my donations tax-deductible?',
    answer: 'Yes, all donations to Happy Faces Society are eligible for 50% tax deduction under Section 80G of the Income Tax Act, 1961. Our registration number is DIT(E)/2020-21/HFS-1234. You will receive an 80G certificate via email within 7 working days of your donation.',
  },
  {
    question: 'How can I volunteer with your organization?',
    answer: 'You can register as a volunteer through our Volunteer page. We offer both virtual and on-ground volunteering opportunities. Virtual volunteers can help with content creation, graphic design, translation, and social media. On-ground volunteers participate in food distribution, blanket distribution, medical camps, teaching programs, community kitchens, and disaster relief operations.',
  },
  {
    question: 'Can I visit your projects to see the impact firsthand?',
    answer: 'Absolutely! We organize donor and volunteer visits to our project sites every month. You can register for a site visit through our Contact form or by emailing happyfaceshyderabad@gmail.com. Visits are currently available across Hyderabad and surrounding areas.',
  },
  {
    question: 'How do you ensure transparency in fund utilization?',
    answer: 'We publish audited annual reports, quarterly impact updates, and real-time campaign progress on our website. Every campaign page includes detailed budget breakdowns, progress photos, and beneficiary updates. Our finances are audited by a reputed firm, and we maintain complete transparency in all operations.',
  },
  {
    question: 'How can I start a fundraiser for Happy Faces Society?',
    answer: 'You can create a personal or corporate fundraiser through our Start Fundraiser page. Whether it is a birthday fundraiser, marathon, corporate CSR initiative, or community event, we provide full support including fundraising toolkits, promotional materials, and a dedicated relationship manager.',
  },
  {
    question: 'Do you accept corporate partnerships and CSR collaborations?',
    answer: 'Yes, we actively collaborate with corporate partners for CSR initiatives, employee volunteering programs, cause marketing campaigns, and grant-funded projects. Our partnerships team can customize programs aligned with your CSR objectives. Contact happyfaceshyderabad@gmail.com for detailed proposals.',
  },
  {
    question: 'How can I get in touch for media and press inquiries?',
    answer: 'For media inquiries, interview requests, and press kits, please contact our Communications team at happyfaceshyderabad@gmail.com or call +91 81435 85288. We also have high-resolution photos, videos, and impact data available for journalists and content creators.',
  },
];